import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {AgentService} from "app/services";
import {toggleQuickPanel} from "app/main/shared-components/quick-panel/store";
import {errorMsg, successMsg} from "app/utils/MessageUtils";
import {fetchAllAgents, fetchAllSubAgents} from "./agents-list.slice";
import { UpdatePaymentBodyTypes} from 'app/types/service-types/AgentTypes';
import AuthService from "app/services/auth.service";
import {ROLES} from "app/constants/roles";

interface UpdatePaymentStateParams {
  id: string;
  body: UpdatePaymentBodyTypes;
  onSuccess?: Function;
  onError?: Function;
}

const isUserAgent = (): boolean => {
  const user = AuthService.handleAuthentication();
  if (!user) return false;
  // @ts-ignore
  const authorities = user.authorities || [];
  const isAdmin = authorities.includes(ROLES.ROLE_ADMIN);
  const isAgent = authorities.includes(ROLES.ROLE_AGENT) && !isAdmin;
  return isAgent;
};

export const updatePayment = (params: UpdatePaymentStateParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await AgentService.updatePaymentAtAgent(params.id, params.body);
    if (response.status >= 200 && response.status < 300) {
      dispatch(setSuccess(true));
      dispatch(toggleQuickPanel());
      dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Payment changed successfully!' : 'Pagesa u ndryshua me sukses!'));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(''));
      const isAgent = isUserAgent();
      // @ts-ignore
      dispatch(isAgent ? fetchAllSubAgents() : fetchAllAgents());
    }
    dispatch(setLoading(false));
  } catch (err) {
    dispatch(setLoading(false));
    dispatch(errorMsg(err.data.message));
    if (params.onError) params.onError();
    dispatch(setError(err.data.message));
  }
}

interface UpdatePaymentSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: UpdatePaymentSlice = {
  error: '',
  success: false,
  loading: false
}

const stateSlice = createSlice({
  name: 'agentedit/update-payment',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setSuccess: (state, action) => {
      state.success = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    }
  }
})

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;